module.exports = "<h4>{{title}}</h4>\r\n\r\n<div style=\"display:block\">\r\n  <canvas baseChart [data]=\"doughnutChartData\" [labels]=\"doughnutChartLabels\" chartType=\"doughnut\"></canvas>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/Documentos/Angular/14-AdminPro/src/app/components/graphic-donut/graphic-donut.component.html
// module id = ../../../../../src/app/components/graphic-donut/graphic-donut.component.html
// module chunks = main